import React, { useContext } from "react";
import useSWR from "swr";
import DirectoryOne from "../../../../../src/assets/images/directory-one.png";
import DirectoryTwo from "../../../../../src/assets/directory/Directory Invite visitor 3.1.webp";
import DirectoryThree from "../../../../../src/assets/directory/Register Directory 4.1.webp";
import directoryApp from "../../../../../src/assets/images/app-directory.png";
import { fetcher } from "../../../../lib/apiConstants";
import { LoginContext } from "../../../../lib/loginContext";
import VideoIntroSection from "../../../../global/components/ProductView/VideoIntroSection";
import FeatureCardView from "../../../../global/components/ProductView/FeatureCardView";
import GooglePlayButton from "../../../../assets/svg/ContentView/GooglePlayButton";
import AppleStoreButton from "../../../../assets/svg/ContentView/AppleStoreButton;";
import UserIcon from "../../../../assets/svg/ContentView/UserIcon";
import Directory from "../../../../assets/svg/ContentView/Directory";


// ── Video Tutorials (You can replace null with real thumbnails later) ──
const videoTutorials = [
  { title: "How to Setup", subtitle: "Learn how to setup Sicunet Directory", thumbnail: null },
  { title: "How to Setup", subtitle: "Learn how to setup Sicunet Directory", thumbnail: null },
  { title: "How to Setup", subtitle: "Learn how to setup Sicunet Directory", thumbnail: null },
  { title: "How to Setup", subtitle: "Learn how to setup Sicunet Directory", thumbnail: null }
];

const DirectoryContent = () => {
  const { data: products, isLoading: productsLoading } = useSWR("products/", fetcher);
  const { isLoggedIn } = useContext(LoginContext);

  return (
    <div className="bg-white font-['Poppins'] text-[#111827]">

      {/* ====================== HERO ====================== */}
      <section className="max-w-[1200px] mx-auto px-6 pt-28 sm:pt-20 lg:pt-16 pb-6 flex flex-col lg:flex-row justify-between items-center gap-8 lg:gap-12">
        {/* Left Text */}
        <div className="flex-1 max-w-full lg:max-w-[853px] text-center lg:text-left">
          <h1 className="text-[#2E4FA2] text-[28px] sm:text-[36px] lg:text-[42px] font-semibold leading-[1.1] mb-6">
            Sicunet Directory           </h1>
          <p className="text-black text-[18px] sm:text-[20px] lg:text-[24px] font-medium leading-[1.6] lg:leading-[42px] mb-6">
            Stay connected to your entry points and never miss a visitor.          </p>

          <p className="text-[#555] text-sm leading-[1.7] max-w-[680px] mb-8 mx-auto lg:mx-0">
            The Sicunet Directory app allows you to receive video calls and messages from your Directory and QR-Plate and take action instantly from your smartphone.          </p>
          {/* <div className="flex justify-center lg:justify-start">
            <button
              className="inline-flex h-12 px-6 items-center justify-center gap-3 rounded-[42px] bg-[#002B98] text-white text-sm font-semibold hover:bg-[#001f6e] transition-colors"
            >
              Setup Tutorial */}
          {/* Play icon */}
          {/* <span className="flex items-center justify-center w-6 h-6 rounded-full ">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21ZM10.783 7.99L16.427 11.126C16.5828 11.2126 16.7126 11.3393 16.803 11.493C16.8934 11.6467 16.9411 11.8217 16.9411 12C16.9411 12.1783 16.8934 12.3533 16.803 12.507C16.7126 12.6607 16.5828 12.7874 16.427 12.874L10.783 16.01C10.6002 16.1116 10.3941 16.1636 10.1851 16.161C9.97599 16.1584 9.77123 16.1013 9.59107 15.9952C9.4109 15.8891 9.26159 15.7377 9.15791 15.5562C9.05424 15.3746 8.9998 15.1691 9 14.96V9.04C8.9998 8.83092 9.05424 8.62541 9.15791 8.44384C9.26159 8.26227 9.4109 8.11094 9.59107 8.00484C9.77123 7.89874 9.97599 7.84156 10.1851 7.83895C10.3941 7.83635 10.6002 7.88842 10.783 7.99Z" fill="white" />
                </svg>
              </span> */}
          {/* </button>
          </div> */}
        </div>

        {/* Right Phone */}
        <div className="flex-shrink-0 w-[260px] h-[310px] sm:w-[360px] sm:h-[430px] lg:w-[498px] lg:h-[594px] pt-4 lg:pt-10">
          <img
            src={directoryApp}
            alt="Sicunet Directory App"
            className="w-full h-full object-contain drop-shadow-2xl"
          />
        </div>
      </section>

      {/* ====================== DOWNLOAD ====================== */}
      <div className="flex flex-col items-center gap-3 pb-16 px-4">
        <p className="text-black text-2xl font-medium">Download Now</p>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href="https://play.google.com/store/apps/details?id=bd.sicunet.sicunetbd_intercom&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-90 transition-opacity"
          >
            <GooglePlayButton />
          </a>

          <a
            href="https://apps.apple.com/us/app/sicunet-directory/id6742125280"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-90 transition-opacity"
          >
            <AppleStoreButton />
          </a>
        </div>
      </div>

      {/* ====================== FEATURE CARDS ====================== */}
      <section className="max-w-[1200px] mx-auto px-6 pb-10 space-y-4">

        <FeatureCardView
          imageLeft={true}
          image={DirectoryOne}
          icon={<Directory />}
          title="Sicunet Directory"
          description="Handling visitors becomes much easier when you can see and respond in real time. With this app, you can receive incoming video calls from the Sicunet Directory Intercom or QR-Plate, view the visitor, communicate if needed, and unlock the door directly during the call. It gives you full control over access, even when you are not physically present."
          brief="The app also supports secure messaging from the intercom, so you can stay informed about visitor activity and respond accordingly. Whether you are at home, in the office, or away, you can manage entry requests without delay."
        />

        <FeatureCardView
          imageLeft={false}
          image={DirectoryTwo}
          description="In addition to intercom communication, the app integrates Sicunet Mobile Credential functionality. Your smartphone can act as a secure access key using Bluetooth and NFC, allowing you to unlock doors quickly and safely without using physical cards."

          brief="Sicunet Directory is designed for users who want both communication and access control in one place. It improves convenience, enhances security, and ensures you never miss important visitor interactions."
        />

        <FeatureCardView
          imageLeft={true}
          image={DirectoryThree}
          description="Using the app is simple. When a visitor calls from the intercom, you receive a video call on your phone. You can view the visitor, communicate if needed, and unlock the door instantly. You can also use your mobile credential for everyday access or remote unlock from anywhere ."
          brief="Sicunet Directory keeps you connected, informed, and in control of your access points at all times."
        />

      </section>

      {/* ====================== VIDEO TUTORIAL ====================== */}
      {/* <VideoIntroSection
        title="Video Tutorial"
        productName="Sicunet Directory"
        videos={videoTutorials}
      /> */}

    </div>
  );
};

export default DirectoryContent;